var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationIco = function SvgLocationIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22a.93.93 0 0 1-.6-.2 1.2 1.2 0 0 1-.375-.525 14 14 0 0 0-1.2-2.625q-.7-1.225-1.975-2.875t-2.075-3.15Q5 11.125 5 9q0-2.925 2.025-4.95Q9.075 2 12 2t4.95 2.05Q19 6.075 19 9q0 2.275-.875 3.8-.85 1.5-1.975 2.975-1.35 1.8-2.05 3a14 14 0 0 0-1.125 2.5 1.13 1.13 0 0 1-.4.55A.98.98 0 0 1 12 22m0-10.5q1.05 0 1.775-.725T14.5 9t-.725-1.775T12 6.5t-1.775.725T9.5 9t.725 1.775T12 11.5"
  })));
};
export default SvgLocationIco;